import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal } from "@/comn/hooks";
import {
    BASE,
    APIS,
    SCHEMA_FORM_VHCL_HLPN_CTGR_CD_SRCH,
    SCHEMA_GRID_VHCL_HLPN_CTGR_CD,
} from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const VehicleHolderCategoryList = (props: any) => {
    const pgeUid = "vhclHlpnCtgrCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        vhclHlpnCtgrCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_VHCL_HLPN_CTGR_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        vhclHlpnCtgrCdLst: useGrid({
            defaultSchema: SCHEMA_GRID_VHCL_HLPN_CTGR_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getVhclHlpnCtgrCdLst: useFetch({
            api: (page = grid.vhclHlpnCtgrCdLst.page) => {
                return APIS.getVhclHlpnCtgrCdLst(
                    form.vhclHlpnCtgrCdSrch.getValues(),
                    page,
                    grid.vhclHlpnCtgrCdLst.size,
                );
            },
            enabled: comnUtils.isEmpty(form.vhclHlpnCtgrCdSrch.errors) && form.vhclHlpnCtgrCdSrch.isSubmitted,
            key: [grid.vhclHlpnCtgrCdLst.page, grid.vhclHlpnCtgrCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.vhclHlpnCtgrCdSrch.getValues(),
                    page: grid.vhclHlpnCtgrCdLst.page,
                    size: grid.vhclHlpnCtgrCdLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.vhclHlpnCtgrCdSrch.handleSubmit(
                () => {
                    grid.vhclHlpnCtgrCdLst.setPage(0);
                    fetch.getVhclHlpnCtgrCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.vhclHlpnCtgrCdLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_VhclHlpnCtgrCdLst: {
            cell: {
                vhclHlpnCtgrCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.vhclHlpnCtgrNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.vhclHlpnCtgrCdLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_VHCL_HLPN_CTGR_CD_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.vhclHlpnCtgrCdSrch.schema.vhclHlpnCtgrCd}></Group.Control>
                                <Group.Control {...form.vhclHlpnCtgrCdSrch.schema.vhclHlpnCtgrNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.vhclHlpnCtgrCdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.vhclHlpnCtgrCdLst.grid}
                            data={fetch.getVhclHlpnCtgrCdLst.data?.vhclHlpnCtgrList}
                            render={render.grid_VhclHlpnCtgrCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
